(ns practitest.frontend.testset2.events
  (:require [ajax.core :as ajax]
            [clojure.string :as str]
            [practitest.frontend.common-entities :refer [build-filter build-grid-query]]
            [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.common-entities.metadata :as metadata]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.grid.localstorage :as grid-localstorage]
            [practitest.frontend.components.grid.server :as server]
            [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.components2.entity-form :as entity-form]
            [practitest.frontend.components2.entity-form.forms :as forms]
            [practitest.frontend.events :as events]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.routing.router :as router]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]
            [tick.core :as t]))

(def testset-index-state-key (:testset subs/index-grid-keys))
(def testsets-instances-state-key (:testsets-instances subs/index-grid-keys))
(def instances-default-per-page server/default-per-page)
(defn testset-saved [{:keys [db]} [_
                                   {:keys [new?
                                           close?]
                                    :as   options}
                                   {:keys [entity]
                                    :as   response}]]

  (let [entity-type :testset
        close-url (broutes/get-url "suites#index" {:p_id (subs/get-current-project-id db)})
        form-id :testset
        entity-id (:id entity)
        newtab (if new?
                 :instances
                 :general)

        db (-> db
               (update :progress disj ::save-testset)
               (forms/reset-form-state-with-entity entity form-id))

        db (if close?
             ;; No need to change DB in Create & Close scenario
             db
             ;; Store returned fields and reset edit form state
             (-> db
                 (update-in [:entity entity-type]
                            (fn [v]
                              (assoc v
                                     :current entity
                                     :state nil
                                     :remote nil
                                     :editing? false)))
                 ;; TODO: don't really need this, cleanup and test
                 (update :options
                         (fn [o]
                           (-> o
                               (assoc :entity-id entity-id))))))]

    {:db db
     :fx (if (and close-url close?)
           ;; Save and close - instances are default tab, so no need to set them
           [[::events/redirect close-url]]
           ;; Just save
           [[:dispatch-n [[::notifications/success2
                           (if new?
                             (get-translation "testset.notification.testset-created" "Test Set was successfully created")
                             (get-translation "testset.notification.testset-saved" "Test Set saved"))
                           {:auto-close notifications/auto-close-success-timeout}]
                          [::entity-form/set-notification-state
                           form-id
                           {:status     "success"
                            :type       :saved
                            :updated-at (t/now)
                            :updated-by (:id (:current-user db))}]
                          [::events/fetch-history]
                          ;; Back navigation doesn't really work here, so we're using replace-state
                          [::router/replace-state :practitest.frontend.testset2/edit {:testset-id entity-id}]]]])}))

(re-frame/reg-event-fx
 ::testset-saved
 testset-saved)

(defn form-state->params
  [db form-state module-state]
  (let [dirty-fields-state (into {}
                                 (comp (filter (fn [[field field-state]]
                                                 (or (:dirty? field-state)
                                                     ;; Pass default values to server too - new form scenario
                                                     (:default-value field-state)
                                                     ;; Always pass name field to satisfy backend checks
                                                     ;; TODO: fix this on backend
                                                     (= :name field))))
                                       (map (fn [[field field-state]]
                                              [field (:value field-state)])))
                                 (:fields form-state))]
    (events/state->params (:fields db) dirty-fields-state module-state)))

(defn save-testset [{db :db} [_ {:keys [close?
                                        new?]
                                 :as   options}]]
  (let [route (if new?
                (broutes/get-route "suites#create" {:p_id (subs/get-current-project-id db)})
                (broutes/get-route "suites#update" {:p_id (subs/get-current-project-id db)
                                                    :id   (subs/get-current-entity-id db :testset)}))]
    {:db (update db :progress conj ::save-testset)
     :http-xhrio
     {:method (:method (:data route))
      :uri    (:path route)
      :params (form-state->params db
                                  (get-in db [:form-states2 :testset])
                                  (get-in db [:entity :testset :module-state]))
      :format (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success [::testset-saved options]
      :on-failure (let [message (if new?
                                  (get-translation "testset.notification.testset-create-error" "Error creating Test Set")
                                  (get-translation "testset.notification.testset-save-error" "Error saving Test Set"))]
                    [::events/api-error ::save-testset {:message message}])}}))

(re-frame/reg-event-fx
 ::save-testset
 save-testset)

(defn fetch-instances [{db :db} [_ grid-query]]
  (let [project-id (subs/get-current-project-id db)
        testset-id (subs/get-current-entity-id db :testset)
        session-key (str project-id "-" (get-in metadata/entities-metadata [:instance :table-id]) "-" testset-id)
        current-page (or (grid-localstorage/load-current-page session-key) 1)
        per-page (or (grid-localstorage/load-per-page session-key) instances-default-per-page)
        final-query (if grid-query
                      grid-query
                      (build-grid-query session-key per-page current-page))
        query-map (merge final-query {:timestamp (.getTime (js/Date.))})]
    {:db (update db :progress conj ::fetch-instances)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "instances#list_instances"
                                        {:p_id   project-id
                                         :set_id testset-id})
      ;; When we press back, chrome uses cache to retrieve results of
      ;; this XHR, so we're adding "unique" timestamp to prevent it doing that
      ;; TODO: handle this on backend ?
      :params          query-map
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::got-instances]
      :on-failure      [::events/api-error ::fetch-instances {}]}}))

(re-frame/reg-event-fx
 ::fetch-instances
 fetch-instances)

(defn- get-table-id [project-id state-key & [testset-id]]
  (if (= state-key testset-index-state-key)
    (str project-id "-testset-index")
    (str project-id "-testset2-testsets-instances-grid" (when testset-id (str "-" testset-id)))))

(re-frame/reg-event-fx
 ::delete-instance
 (fn [{db :db} [_ instance-id is-testsets-instances?]]
   {:http-xhrio
    {:method          :delete
     :uri             (broutes/get-url "instances#destroy"
                                       {:p_id (subs/get-current-project-id db)
                                        :id   instance-id})
     :format          (ajax/json-request-format)
     :response-format (ajax/json-response-format {:keywords? true})
     :on-success      [::instance-deleted is-testsets-instances?]
     :on-failure      [::delete-instance-error]}}))

(re-frame/reg-event-fx
 ::instance-deleted
 (fn [{db :db} [_ is-testsets-instances?]]
   ;; TODO: server-side pagination ?
   (if is-testsets-instances?
     (let [project-id @(re-frame/subscribe [::subs/current-project-id])
           testset-id @(re-frame/subscribe [::subs/current-entity-id :testset])
           grid-filter (grid-session-storage/load-autofilters (get-table-id project-id testsets-instances-state-key testset-id))]
       {:dispatch-n [[::common-events/fetch-entity-list :testset testsets-instances-state-key grid-filter]
                     [::notifications/success2
                      (get-translation "testset.notification.delete-instance-success" "Instance deleted successfuly")]]})
     {:dispatch-n [[::fetch-instances]
                   [::fetch-graphs]
                   [::events/fetch-entity :current]
                   [::notifications/success2
                    (get-translation "testset.notification.delete-instance-success" "Instance deleted successfuly")]]})))

(re-frame/reg-event-fx
 ::delete-instance-error
 (fn [{db :db} _]
   {:dispatch [::notifications/error2 (get-translation "testset.notification.delete-instance-error" "Error deleting instance")
               {:id "api-error-message"}]}))

(re-frame/reg-event-fx
 ::batch-delete-instances
 (fn [{db :db} [_ instance-ids is-instance-view? testset-id]]
   {:http-xhrio
    {:method          :post
     :uri             (broutes/get-url "instances#batch_delete_apply"
                                       {:p_id (subs/get-current-project-id db)})
     :params          (if (= instance-ids :_all)
                          {:ids "_all"
                           :set_id testset-id}
                        {:ids (str/join "," instance-ids)})

     :format          (ajax/json-request-format)
     :response-format (ajax/json-response-format {:keywords? true})

     :on-success      [::batch-instances-deleted is-instance-view?]
     :on-failure      [::batch-delete-instances-error]}}))

(re-frame/reg-event-fx
 ::batch-instances-deleted
 (fn [{db :db} [_ is-instance-view? response]]
   (let [status (:status response)
         project-id @(re-frame/subscribe [::subs/current-project-id])
         testset-id @(re-frame/subscribe [::subs/current-entity-id :testset])
         grid-filter (grid-session-storage/load-autofilters (get-table-id project-id testsets-instances-state-key testset-id))
         message (:message response)]
     (if (= status "ok")
       ;; Success case
       (if is-instance-view?
         ;; Instance view - dispatch common entity list fetch
         {:dispatch-n [[::notifications/success2
                        (or message
                            (get-translation "testset.notification.batch-delete-instances-success" "Instances deleted successfuly"))
                        {:auto-close 1000}]
                       [::common-events/fetch-entity-list :testset testsets-instances-state-key grid-filter]]}
         ;; Not instance view - dispatch specific fetches
         {:dispatch-n [[::notifications/success2
                        (or message
                            (get-translation "testset.notification.batch-delete-instances-success" "Instances deleted successfuly"))
                        {:auto-close 1000}]
                       [::fetch-instances]
                       [::fetch-graphs]
                       [::events/fetch-entity :current]]})
       ;; Error case
       {:dispatch [::notifications/error2
                   (or message
                       (get-translation "testset.notification.batch-delete-instances-error" "Error deleting instances"))
                   {:id "api-error-message"}]}))))

(re-frame/reg-event-fx
 ::batch-delete-instances-error
 (fn [{db :db} _]
   {:dispatch [::notifications/error2
               (get-translation "testset.notification.batch-delete-instances-error" "Error deleting instances")
               {:id "api-error-message"}]}))

(def default-filter
  {:id   "_DEFAULT_"
   :name "All Tests"})

(defn- add-instances-modal-fragment-check!
  [new-show?]
  (if new-show?
    ;; We don't care about value - only about key presence
    (router/update-fragment! assoc :add-instances "")
    (router/update-fragment! dissoc :add-instances)))

(re-frame/reg-event-fx
 ::restore-add-instances-modal
 (fn [_ _]
   (when-let [current-fragment (router/get-current-fragment-decoded)]
     (when (:add-instances current-fragment)
       ;; TODO: per-page stuff ?
       {:dispatch [::toggle-add-instances-modal]}))))

(defn toggle-add-instances [{db :db} [_ per-page-instances-grid-load]]
  (let [new-show? (not (get-in db [:entity :testset :add-instances-state :show-add-instances?]))
        filter (get-in db [:entity :testset :add-instances-state :current-filter-selected])
        per_page (when (fn? per-page-instances-grid-load)
                   (per-page-instances-grid-load))
        per_page (or per_page server/default-per-page)          ; could be nil, so taking default
        query (merge server/default-query {:per_page per_page})]
    (add-instances-modal-fragment-check! new-show?)

    (cond-> {:db (-> db
                     (assoc-in [:entity :testset :add-instances-state]
                               {:show-add-instances?     new-show?
                                :current-page            1
                                :selected-tests          #{}
                                :current-filter-selected filter}))}

      ;; Fetch on toggle
      new-show?
      (assoc :dispatch-n [[::events/fetch-filters :test
                           [:entity :testset :add-instances-state :filters]]
                          ;; Use default params
                          [::fetch-tests query]]))))
(re-frame/reg-event-fx
 ::toggle-add-instances-modal
 toggle-add-instances)

(defn got-instances [db [_ {:keys [data
                                   per_page
                                   current_page
                                   total_count
                                   full]}]]

  (-> db
      (assoc-in [:entity :testset :instances-state]
                {:data      (:items data)
                 :selection #{}})
      (assoc-in [:entity :testset :stale-grid?] false)
      (update-in [:entity :testset :instances-state] assoc
                 ;; Selection uses this
                 ;; TODO: refactor this hidden dependency
                 :data data
                 :current-page current_page
                 ;:per-page per_page
                 :total-count total_count
                 :full-data? (boolean full)
                 ;; Sync filters
                 ;:current-filter-fetched (get-in db [:entity :testset :instances-state :current-filter-selected])
                 )

      (update :progress disj ::fetch-instances
              ;; TODO: fix this
              :practitest.frontend.testset2/sort-instances)))

(re-frame/reg-event-db
 ::got-instances
 got-instances)

(defn got-tests [db [_ {:keys [data
                               per_page
                               current_page
                               total_count
                               full
                               filter_columns]}]]
  (-> db
      (update-in [:entity :testset :add-instances-state] assoc
                 ;; Selection uses this
                 ;; TODO: refactor this hidden dependency
                 :data data
                 :current-page current_page
                 :per-page per_page
                 :total-count total_count
                 :full-data? (boolean full)
                 ;; Sync filters
                 :filter-cols filter_columns
                 :current-filter-fetched (get-in db [:entity :testset :add-instances-state :current-filter-selected]))
      (update :progress disj ::fetch-tests)))

(re-frame/reg-event-db
 ::got-tests
 got-tests)

;; TODO: progress conj/disj as interceptors ??
(re-frame/reg-event-fx
 ::fetch-tests-failed
 (fn [{db :db} _]
   {:db       (-> db
                  (update :progress disj ::fetch-tests)
                  ;; Reset selected filter back to the last fetched one
                  (assoc-in [:entity :testset :add-instances-state :current-filter-selected]
                            (get-in db [:entity :testset :add-instances-state :current-filter-fetched])))
    :dispatch [::notifications/error "Error fetching tests" {:auto-close 1000}]}))

(defn fetch-tests [{db :db} [_ _state-key grid-query]]
  (let [filter (get-in db [:entity (:current-entity db) :add-instances-state :current-filter-selected])
        query-map (build-filter filter)
        query-map (merge query-map grid-query)]
    {:db (update db :progress conj ::fetch-tests)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "qtest_designs#list2"
                                        {:p_id (subs/get-current-project-id db)})
      :format          :url
      :vec-strategy    :rails
      :params          query-map
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::got-tests]
      :on-failure      [::fetch-tests-failed]}}))

(re-frame/reg-event-fx
 ::fetch-tests
 fetch-tests)

;;; ::got-graphs
(defn got-graphs [db [_ graphs]]
  (-> db
      (assoc-in [:entity :testset :graphs] graphs)
      (update :progress disj ::fetch-graphs)))

(re-frame/reg-event-db
 ::got-graphs
 got-graphs)

;;; ::fetch-graphs
(defn fetch-graphs [{db :db} _]
  {:db (update db :progress conj ::fetch-graphs)
   :http-xhrio
   {:method          :get
    :uri             (broutes/get-url "suites#graphs"
                                      {:p_id (subs/get-current-project-id db)
                                       :id (subs/get-current-entity-id db :testset)})
    :response-format (ajax/json-response-format {:keywords? true})
    :on-success      [::got-graphs]
    :on-failure      [::events/api-error ::fetch-graphs {}]}})

(re-frame/reg-event-fx
 ::fetch-graphs
 fetch-graphs)

(defn add-instances [{db :db} [_ test-ids grid-state]]
  (let [test-ids (str/join "," test-ids)]
    {:db (update db :progress conj ::add-instances)
     :http-xhrio
     {:method          :post
      :uri             (broutes/get-url "suites#add_tests"
                                        {:p_id (subs/get-current-project-id db)
                                         :id (subs/get-current-entity-id db :testset)})
      :body            (doto
                        (js/FormData.)
                         (.append "tests_ids" test-ids))
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::added-instances grid-state]
      ;; TODO: correct error handling
      :on-failure      [::events/api-error ::add-instances {:message "Unable to add instances"}]}}))

(re-frame/reg-event-fx
 ::add-instances
 add-instances)

(defn added-instances [{db :db} [_ grid-state response]]
  (if-let [error (:error response)]
    {:db (update db :progress disj ::add-instances)
     :dispatch [::notifications/error2 error]}
    {:db         (-> db
                     (update :progress disj ::add-instances)
                     (assoc-in [:entity :testset-view :added-tests] []))
     :dispatch-n  [[::fetch-instances (server/build-query {:local-state-updating grid-state} 1)]
                   [::fetch-graphs]
                   [::events/fetch-history]
                   [::events/fetch-entity :current]
                   [::hide-add-instances-modal]]}))

(re-frame/reg-event-fx
 ::added-instances
 added-instances)

(re-frame/reg-event-db
 ::hide-add-instances-modal
 (fn [db _]
   (add-instances-modal-fragment-check! false)

   (-> db
       (assoc-in [:entity :testset :add-instances-state :show-add-instances?] false))))

(re-frame/reg-event-db
 ::clear-selection
 (fn [db _]
   (-> db
       (assoc-in [:entity :testset :add-instances-state :selection] #{}))))

(re-frame/reg-event-db
 ::show-views
 (fn [db _]
   (-> db
       (assoc-in [:entity :testset :add-instances-state :add-instances-show-views?] true))))

(re-frame/reg-event-db
 ::hide-views
 (fn [db _]
   (-> db
       (assoc-in [:entity :testset :add-instances-state :add-instances-show-views?] false))))

(re-frame/reg-event-db
 ::set-current-page
 (fn [db [_ page]]
   (assoc-in db [:entity :testset :add-instances-state :current-page] page)))

(re-frame/reg-event-db
 ::set-current-tab
 (fn [db [_ tab-key]]
   (assoc-in db [:entity :testset :module-state :current-tab] tab-key)))

(re-frame/reg-event-db
 ::set-instances-to-add
 (fn [db [_ ids]]
   (assoc-in db [:entity :testset :module-state :instances-to-add] ids)))

(re-frame/reg-event-db
 ::set-suite-created-from
 (fn [db [_ created-from]]
   (assoc-in db [:entity :testset :module-state :created-from] created-from)))

(def instance-view-mode-storage-key "testset-instance-view-mode")

(defn- get-instance-view-storage-key [project-id]
  (str instance-view-mode-storage-key "-" project-id))

(defn- save-instance-view-mode [project-id mode]
  (when project-id
    (dom/set-item (get-instance-view-storage-key project-id) (str mode))))

(defn- load-instance-view-mode [project-id]
  (when project-id
    (let [stored-value (dom/get-item (get-instance-view-storage-key project-id))]
      (when stored-value
        (= stored-value "true")))))

(re-frame/reg-event-fx
 ::set-instance-view-mode
 (fn [{:keys [db]} [_ is-instance-view]]
   (let [fields @(re-frame/subscribe [::subs/fields])
         state-key (if is-instance-view
                     testsets-instances-state-key
                     testset-index-state-key)
         current-tab  @(re-frame/subscribe [::grid.subs/current-tab :testset state-key])
         current-view @(re-frame/subscribe [::grid.subs/current-view :testset state-key])
         project-id @(re-frame/subscribe [::subs/current-project-id])
         testset-id @(re-frame/subscribe [::subs/current-entity-id :testset])
         current-view_id (:id current-view)
         table-id (get-table-id project-id state-key (when is-instance-view testset-id))
         per-page (or (grid-localstorage/load-per-page table-id)
                      @(re-frame/subscribe [::grid.subs/entities-per-page :testset state-key])
                      10)
         base-query {:per_page per-page
                     :page 1
                     :order_direction (if is-instance-view "asc" "desc")
                     :order_by (if is-instance-view "suite_name" "display_id")}
         default-query (cond
                         (= current-tab "folders") (assoc base-query :folder current-view_id)
                         (= current-tab "filters") (assoc base-query :cv current-view_id)
                         :else base-query)
         grid-filter-raw (grid-session-storage/load-autofilters table-id)
         ;; Process the grid filter to handle user objects in assigned_to fields
         grid-filter (server/autofilters->json (server/process-autofilters grid-filter-raw fields))
         query (if grid-filter
                 (assoc default-query :gridfilter grid-filter)
                 default-query)]
     (save-instance-view-mode project-id is-instance-view)
     {:db (-> db
              (assoc-in [:entity :testset :instance-view-mode?] is-instance-view))
      :dispatch [::common-events/fetch-entity-list :testset state-key query]})))

(re-frame/reg-event-fx
 ::initialize-instance-view-mode
 (fn [{:keys [db]} _]
   (let [project-id @(re-frame/subscribe [::subs/current-project-id])
         stored-mode (load-instance-view-mode project-id)
         query-params (router/get-current-query-params)
         instance-view-param (:instance_view_mode query-params)
         instance-view-mode (if (some? instance-view-param)
                              (= "true" instance-view-param)
                              (boolean stored-mode))]
     {:db (assoc-in db [:entity :testset :instance-view-mode?] instance-view-mode)})))

;; Toggle enforce run order for a test set
(re-frame/reg-event-fx
 ::toggle-enforce-run-order
 (fn [{:keys [db]} [_ testset-id enforce-run-order?]]
   (let [project-id @(re-frame/subscribe [::subs/current-project-id])
         uri (broutes/get-url "suite#toggle_enforce_run_order" {:p_id project-id :id testset-id})]
     {:db (update db :progress conj ::toggle-enforce-run-order)
      :http-xhrio
      {:method          :post
       :uri             uri
       :params          {:enforce_run_order enforce-run-order?}
       :format          (ajax/json-request-format)
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success      [::toggle-enforce-run-order-success]
       :on-failure      [::toggle-enforce-run-order-error]}})))

;; Handle successful toggle of enforce run order
(re-frame/reg-event-fx
 ::toggle-enforce-run-order-success
 (fn [{:keys [db]} [_ response]]
   (let [enforce-run-order? (:enforce_run_order response)
         message (if enforce-run-order?
                   (get-translation "testset.notify.run_order_enabled" "Run order enforcement enabled for this Test Set")
                   (get-translation "testset.notify.run_order_disabled" "Run order enforcement disabled for this Test Set"))]
     {:db (-> db
              (update :progress disj ::toggle-enforce-run-order)
              (assoc-in [:entity :testset :current :enforce_run_order] enforce-run-order?))
      :dispatch-n [[::notifications/success2 message {:id "enforce-run-order-notification" :auto-close true}]
                   [::fetch-instances]]})))

(def linked-issues-default-per-page server/default-per-page)

(re-frame/reg-event-fx
 ::fetch-linked-issues
 (fn [{db :db} [_ grid-query]]
   (let [project-id (subs/get-current-project-id db)
         testset-id (subs/get-current-entity-id db :testset)
         table-id (str project-id "-testset-linked-issues")
         table-id-with-testset (str table-id "-" testset-id)
         per-page (or (grid-localstorage/load-per-page table-id) linked-issues-default-per-page)
         current-page (or (grid-localstorage/load-current-page table-id-with-testset) 1)
         query (or grid-query {:page current-page :per_page per-page})]
     {:db (update db :progress conj ::fetch-linked-issues)
      :http-xhrio
      {:method          :get
       :uri             (broutes/get-url "suites#linked_issues"
                                         {:p_id project-id
                                          :id   testset-id})
       :params          (merge query {:timestamp (.getTime (js/Date.))})
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success      [::got-linked-issues]
       :on-failure      [::events/api-error ::fetch-linked-issues {}]}})))

(re-frame/reg-event-db
 ::got-linked-issues
 (fn [db [_ {:keys [data per_page current_page total_count full]}]]
   (-> db
       (update :progress disj ::fetch-linked-issues)
       (assoc-in [:entity :testset :linked-issues-state]
                 {:data         data
                  :current-page current_page
                  :total-count  total_count
                  :full-data?   (boolean full)}))))

;; Handle error when toggling enforce run order
(re-frame/reg-event-fx
 ::toggle-enforce-run-order-error
 (fn [{:keys [db]} [_ response]]
   (let [error-message (or (get-in response [:response :errors])
                           "Error updating run order enforcement setting")]
     {:db (update db :progress disj ::toggle-enforce-run-order)
      :dispatch [::notifications/error2 error-message
                 {:id "api-error-message" :auto-close true}]})))